import IMAGES from '@/assets/images';
import CustomImage from '@/components/CustomImage';
import useAuth from '@/hooks/useAuth';
import AuthLayout, {
  TimelineContent,
  TimelineIcon,
} from '@/layouts/AuthLayout';
import { Button, Flex, Timeline } from 'antd';
import { useNavigate } from 'react-router';
import BasicInfoIcon from './SelfOnboard/_icons/BasicInfoIcon';
import PaymentIcon from './SelfOnboard/_icons/PaymentIcon';
import PlanInfoIcon from './SelfOnboard/_icons/PlanInfoIcon';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const { verifiedInfo } = useAuth();

  const handleGoToDashboard = () => {
    if (verifiedInfo?.id) {
      navigate('/onboard', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  };
  const items = [
    {
      dot: <TimelineIcon isActive={true} Icon={BasicInfoIcon} />,
      children: (
        <TimelineContent
          title="Basic Info"
          subtitle="Company Basic information"
        />
      ),
    },
    {
      dot: <TimelineIcon isActive={true} Icon={PlanInfoIcon} />,
      children: (
        <TimelineContent title="Subscriptions" subtitle="Select Plan" />
      ),
    },
    {
      dot: <TimelineIcon isActive={true} Icon={PaymentIcon} />,
      children: <TimelineContent title="Payment" subtitle="Payment Status" />,
    },
  ];

  return (
    <AuthLayout
      leftContent={
        <>
          <div className="mt-2 w-full flex justify-center z-10">
            <CustomImage
              alt="main_logo"
              src={IMAGES.mainLogo}
              className="w-40 h-24"
            />
          </div>
          <Timeline className="onboard-timeline z-10" items={items} />
        </>
      }
    >
      <div className="flex flex-col items-center justify-center h-full">
        <CustomImage width={100} height={100} src={IMAGES.paymentFailed} />
        <div className="text-center">
          <h1 className="text-3xl text-white font-bold mb-4">Payment Failed</h1>
          <p className="text-white text-lg max-w-sm">
            Your payment was rejected due to invalid information!
          </p>
          <Flex align="center" gap={8} justify="center">
            <Button
              onClick={() => navigate('/login', { replace: true })}
              className="mt-4 h-11 !min-w-40 shrink-0 border-theme-gray-700 hover:!border-theme-gray-700 bg-theme-slate-800 hover:!bg-theme-slate-800 text-white hover:!text-white"
              size="large"
            >
              Cancel
            </Button>
            <Button
              onClick={handleGoToDashboard}
              className="mt-4 btn-primary h-11 !min-w-40 shrink-0"
              size="large"
            >
              Try Again
            </Button>
          </Flex>
        </div>
      </div>
    </AuthLayout>
  );
};

export default PaymentFailed;
